import type { SVGProps } from "react";

export const LocationPinTwoToneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="17"
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M0 7.25682C0 3.26965 3.35588 0 7.3125 0C11.2691 0 14.625 3.26965 14.625 7.25682C14.625 9.29192 13.7627 11.0029 12.5525 12.4153C11.3469 13.8222 9.77661 14.9571 8.30135 15.8598L8.29289 15.865L8.28426 15.8699C7.98784 16.0372 7.65297 16.125 7.3125 16.125C6.97203 16.125 6.63716 16.0372 6.34074 15.8699L6.33084 15.8643L6.32118 15.8583C4.85126 14.9484 3.28122 13.8171 2.07517 12.4144C0.8639 11.0056 0 9.29867 0 7.25682Z"
      fill="#4075FF"
    />
    <path
      d="M4.3125 7.3125C4.3125 5.65565 5.65565 4.3125 7.3125 4.3125C8.96935 4.3125 10.3125 5.65565 10.3125 7.3125C10.3125 8.96935 8.96935 10.3125 7.3125 10.3125C5.65565 10.3125 4.3125 8.96935 4.3125 7.3125Z"
      fill="#4075FF"
    />
  </svg>
);
